<template>
  <div
    class="speedyLogin"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="正在登录..."
  ></div>
</template>

<script>
export default {
  name: 'SpeedyLogin',
  data() {
    return {
      fullscreenLoading: false,
      code: '',
      token: ''
    }
  },
  created() {
    this.fullscreenLoading = true
    // code
    this.code = this.$route.query.code

    // code换取token
    let params = {
      code: this.code
    }
    this.$ajax
      .post(this.$api.basicdata.customer_enter, params)
      .then((res) => {
        this.token = res.data

        this.$store.commit('SET_TOKEN', this.token)
        localStorage.setItem('login_token', this.token)

        this.$store.dispatch('queryMenu').then(() => {
          // 遍历权限，跳转第一个页面
          for (let i = 0; i < this.$store.state.menus.length; i++) {
            if (this.$store.state.menus[i].isPermission === 'Y') {
              if (this.$store.state.menus[i].childList) {
                for (let j = 0; j < this.$store.state.menus[i].childList.length; j++) {
                  if (this.$store.state.menus[i].childList[j].isPermission === 'Y') {
                    this.$router.push(this.$store.state.menus[i].childList[j].url)
                    return false
                  }
                }
              } else {
                this.$router.push(this.$store.state.menus[i].url)
                break
              }
            }
          }
        })
      })
      .catch(() => {})
  }
}
</script>

<style lang="less" scoped>
.speedyLogin {
  width: 100%;
  height: 100%;
}
</style>
